import { faEye } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    ColumnDescription,
    TableChangeState,
} from "react-bootstrap-table-next";
import Table from "../../../Components/Table";
import {
    ExportarExcelListarGestaoLogsControleReparoService,
    ListarGestaoLogsControleReparoController,
} from "../../../Controllers/Geral/GestaoLogsControleReparo/GestaoLogsControleReparoControllers";
import useAsyncEffect from "../../../hooks/useAsyncEffect";
import {
    IGestaoLogsControleReparo,
    IGestaoLogsControleReparoFiltro,
} from "../../../Interfaces/Geral/GestaoLogsControleReparo/GestaoLogsControleReparoInterface";
import FiltroGestaoLogsControleReparo from "../../../Components/CardsPages/Geral/GestaoLogsControleReparo/FiltroGestaoLogsControleReparo";
import { Dispatch, SetStateAction, useRef, useState } from "react";
import usePaginationFilter from "../../../hooks/usePaginationFilter";
import ExportExcel from "../../../Components/StickyToolbar/ExportExcel";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";
import { ACESSOS } from "../../../Routes/Acessos";

const filtroInicial: IGestaoLogsControleReparoFiltro = {
    ID_CASO: 0,
    ID_ETAPA_TIPO_CASO: 0,
    DT_INICIO: "",
    DT_FIM: "",
    DS_CLIENTE: "",
    NR_CPF: "",
    ID_EMPREENDIMENTO: [],
    ID_PRODUTO: [],
    ID_USUARIO: 0,
    DS_ACAO: "",
    DS_PESQUISA: "",
};

interface IPropsTableChange extends TableChangeState<any> {
    searchText: string;
}

export default function GestaoLogsControleReparo() {
    const [idEmpreendimento, setIdEmpreendimento] = useState<string | number[]>(
        []
    );
    const [idProduto, setIdProduto] = useState<string | number[]>([]);
    const [pesquisaText, setPesquisaText] = useState("");

    const [idUsuario, setIdUsuario] = useState(0);
    const [idEtapa, setIdEtapa] = useState(0);
    const FILTRO_GESTAO_LOGS_CONTROLE_REPARO = sessionStorage.getItem(
        "FILTRO_GESTAO_LOGS_CONTROLE_REPARO"
    );

    const { PageFilter, setPage, filter, setFilter } =
        usePaginationFilter<IGestaoLogsControleReparoFiltro>({
            page: 1,
            filter: FILTRO_GESTAO_LOGS_CONTROLE_REPARO
                ? JSON.parse(FILTRO_GESTAO_LOGS_CONTROLE_REPARO)
                : filtroInicial,
        });

    const handleDateChange = (formData: IGestaoLogsControleReparoFiltro) => {
        const filterFormData = {
            ...formData,
            ID_CASO: formData.ID_CASO ? formData.ID_CASO : 0,
            DT_INICIO: formData.DT_INICIO ?? "",
            DT_FIM: formData.DT_FIM ?? "",
            DS_CLIENTE: formData.DS_CLIENTE ?? "",
            NR_CPF: formData.NR_CPF ?? "",
            DS_ACAO: formData.DS_ACAO ?? "",
            DS_PESQUISA: formData.DS_PESQUISA ?? "",
            ID_USUARIO: idUsuario,
            ID_ETAPA_TIPO_CASO: idEtapa,
            ID_EMPREENDIMENTO: Array.isArray(idEmpreendimento)
                ? idEmpreendimento
                : [],
            ID_PRODUTO: Array.isArray(idProduto) ? idProduto : [],
        };
        PageFilter.page = 1;
        setFilter(filterFormData);
        sessionStorage.setItem(
            "FILTRO_GESTAO_LOGS_CONTROLE_REPARO",
            JSON.stringify(filterFormData)
        );
    };

    const {
        value: lstGestaoLogsControleReparo,
        loading: lstGestaoLogsControleReparoLoading,
    } = useAsyncEffect(
        () =>
            ListarGestaoLogsControleReparoController(
                PageFilter.page,
                {
                    ID_CASO: filter?.ID_CASO ?? 0,
                    ID_ETAPA_TIPO_CASO: idEtapa,
                    DT_INICIO: filter?.DT_INICIO ?? "",
                    DT_FIM: filter?.DT_FIM ?? "",
                    DS_CLIENTE: filter?.DS_CLIENTE ?? "",
                    NR_CPF: filter?.NR_CPF ?? "",
                    ID_EMPREENDIMENTO: Array.isArray(idEmpreendimento)
                        ? idEmpreendimento
                        : [],
                    ID_PRODUTO: Array.isArray(idProduto) ? idProduto : [],
                    ID_USUARIO: idUsuario,
                    DS_ACAO: filter?.DS_ACAO ?? "",
                    DS_PESQUISA: filter?.DS_PESQUISA ?? "",
                },
                false // excel
            ),
        [filter, PageFilter]
    );

    const ultimaPesquisaRef = useRef("");

    function handleSearch(searchValue: string, newState: IPropsTableChange) {
        ultimaPesquisaRef.current = searchValue;

        setTimeout(() => {
            if (ultimaPesquisaRef.current === searchValue) {
                setFilter({
                    ...filter,
                    DS_PESQUISA: newState.searchText,
                });
                setPage(newState.page);
            }
        }, 1500);
    }

    const totalPaginas = Math.ceil(
        lstGestaoLogsControleReparo?.[0]?.TOTAL / 10
    );

    const columns: Array<ColumnDescription<IGestaoLogsControleReparo>> = [
        {
            dataField: "ID_CASO",
            classes: "p-3 ws-nowrap align-middle text-center",
            text: "",
            formatter: (c) => (
                <OverlayTrigger
                    overlay={
                        <Tooltip id="ver-atendimento-tooltip">
                            Ver Atendimento
                        </Tooltip>
                    }
                >
                    <Link
                        to={ACESSOS.ASSISTENCIA.TELAS.ATENDIMENTO.DS_LINK(
                            Number(c)
                        )}
                        className="m-2 btn btn-icon btn-outline-info"
                    >
                        <FontAwesomeIcon icon={faEye} />
                    </Link>
                </OverlayTrigger>
            ),
        },
        {
            dataField: "ID_CASO",
            text: "Caso",
            classes: "p-3 ws-nowrap align-middle text-center",
            headerAlign: "center",
            formatter: (c) => (
                <div className="d-flex justify-content-center align-items-center">
                    <span className="mr-2 font-weight-bold">{c}</span>
                </div>
            ),
        },
        {
            dataField: "DS_USUARIO",
            text: "Usuário",
            classes: "p-3 ws-nowrap align-middle text-center",
            headerAlign: "center",
            formatter: (c) => (
                <div className="d-flex justify-content-center align-items-center">
                    <span className="symbol symbol-40 symbol-light-primary flex-shrink-0">
                        {c}
                    </span>
                </div>
            ),
        },
        {
            dataField: "DS_ACAO",
            text: "Ação",
            classes: "p-4 ws-nowrap align-middle text-center",
            headerAlign: "center",
            formatter: (c) => (
                <div className="d-flex justify-content-center align-items-center">
                    {c === "INSERÇÃO" && (
                        <span className="label label-lg font-weight-bold label-light-success label-inline mr-2">
                            {c}
                        </span>
                    )}
                    {c === "EDIÇÃO" && (
                        <span className="label label-lg font-weight-bold label-light-warning label-inline mr-2">
                            {" " + c + " "}
                        </span>
                    )}
                    {c === "EXCLUSÃO" && (
                        <span className="label label-lg font-weight-bold label-light-danger label-inline mr-2">
                            {c}
                        </span>
                    )}
                </div>
            ),
        },
        {
            dataField: "DT_CADASTRO",
            text: "Dt. ação",
            classes: "p-4 ws-nowrap align-middle text-center",
            headerAlign: "center",
            formatter: (c) => (
                <div className="font-weight-bolder text-primary mb-0">
                    <span className="mr-2">
                        {c ? new Date(c).toLocaleString() : ""}
                    </span>
                </div>
            ),
        },
        {
            dataField: "DT_INICIO_REPARO",
            text: "Dt. início reparo",
            classes: "p-4 ws-nowrap align-middle text-center",
            headerAlign: "center",
            formatter: (c) => (
                <div className="font-weight-bolder text-primary mb-0">
                    <span className="mr-2">
                        {c ? new Date(c).toLocaleString() : ""}
                    </span>
                </div>
            ),
        },
        {
            dataField: "DT_FINAL_REPARO",
            text: "Dt. final reparo",
            classes: "p-4 ws-nowrap align-middle text-center",
            headerAlign: "center",
            formatter: (c) => (
                <div className="font-weight-bolder text-primary mb-0">
                    <span className="mr-2">
                        {c ? new Date(c).toLocaleString() : ""}
                    </span>
                </div>
            ),
        },
        {
            dataField: "DS_NOME",
            text: "Nome",
            classes: "p-4 ws-nowrap align-middle text-center",
            headerAlign: "center",
        },
        {
            dataField: "DS_SERVICO_REALIZADO",
            text: "Serviço",
            classes: "p-4 ws-nowrap align-middle text-center",
            headerAlign: "center",
        },
        {
            dataField: "VL_SERVICO_REALIZADO",
            text: "Vl. serviço",
            classes: "p-4 ws-nowrap align-middle text-center",
            headerAlign: "center",
            formatter: (c) => (
                <div className="d-flex justify-content-center align-items-center">
                    <span className="mr-2 font-weight-bold">
                        {c ? `R$ ${c}` : ""}
                    </span>
                </div>
            ),
        },
        {
            dataField: "DS_EQUIPE_UTILIZADA",
            text: "Equipe",
            classes: "p-3 ws-nowrap align-middle text-center",
            headerAlign: "center",
        },
        {
            dataField: "VL_EQUIPE_UTILIZADA",
            text: "Vl. equipe",
            classes: "p-4 ws-nowrap align-middle text-center",
            headerAlign: "center",
            formatter: (c) => (
                <div className="d-flex justify-content-center align-items-center">
                    <span className="mr-2 font-weight-bold">
                        {c ? `R$ ${c}` : ""}
                    </span>
                </div>
            ),
        },
        {
            dataField: "DS_MATERIAL_UTILIZADO",
            text: "Material",
            classes: "p-4 ws-nowrap align-middle text-center",
            headerAlign: "center",
        },
        {
            dataField: "VL_MATERIAL_UTILIZADO",
            text: "Vl. material",
            classes: "p-4 ws-nowrap align-middle text-center",
            headerAlign: "center",
            formatter: (c) => (
                <div className="d-flex justify-content-center align-items-center">
                    <span className="mr-2 font-weight-bold">
                        {c ? `R$ ${c}` : ""}
                    </span>
                </div>
            ),
        },
        {
            dataField: "DS_EQUIPAMENTO_UTILIZADO",
            text: "Equipamento",
            classes: "p-4 ws-nowrap align-middle text-center",
            headerAlign: "center",
        },
        {
            dataField: "VL_EQUIPAMENTO_UTILIZADO",
            text: "Vl. equipamento",
            classes: "p-4 ws-nowrap align-middle text-center",
            headerAlign: "center",
            formatter: (c) => (
                <div className="d-flex justify-content-center align-items-center">
                    <span className="mr-2 font-weight-bold">
                        {c ? `R$ ${c}` : ""}
                    </span>
                </div>
            ),
        },
        {
            dataField: "DS_DESLOCAMENTO_UTILIZADO",
            text: "Deslocamento",
            classes: "p-4 ws-nowrap align-middle text-center",
            headerAlign: "center",
        },
        {
            dataField: "VL_DESLOCAMENTO_UTILIZADO",
            text: "Vl. deslocamento",
            classes: "p-4 ws-nowrap align-middle text-center",
            headerAlign: "center",
            formatter: (c) => (
                <div className="d-flex justify-content-center align-items-center">
                    <span className="mr-2 font-weight-bold">
                        {c ? `R$ ${c}` : ""}
                    </span>
                </div>
            ),
        },
    ];

    return (
        <div className="d-flex justify-content-center card card-body">
            <h1 className="text-center">
                Trilha de Auditoria - Controle de Reparo
            </h1>
            <div className="d-flex flex-column">
                <div className="d-flex justify-content-between">
                    <h3 className="d-flex align-items-end">
                        Logs de controle de reparo
                    </h3>
                </div>
                <Table
                    columns={columns}
                    data={lstGestaoLogsControleReparo ?? []}
                    loading={lstGestaoLogsControleReparoLoading}
                    keyField="ID_CASO"
                    onTableChange={(_type, newState) => {
                        const state = newState as IPropsTableChange;

                        if (state.searchText !== "") {
                            handleSearch(state.searchText, state);
                            setPesquisaText(state.searchText);
                        } else if (pesquisaText.length > 0) {
                            setFilter({
                                ...filter,
                                DS_PESQUISA: state.searchText,
                            });
                        } else {
                            setPage(state.page);
                        }
                    }}
                    tableView={{
                        columns: columns,
                        noSort: true,
                        sizePerPage: 10,
                        cancelYScroll: true,
                        defaultStyle: true,
                    }}
                    remote={{ pagination: true }}
                    noDataIndication={() => (
                        <div className="text-black-50 text-center">
                            Nenhum log encontrado
                        </div>
                    )}
                    totalPages={totalPaginas}
                    bordered={false}
                    noHover
                    noSearch
                />
                <FiltroGestaoLogsControleReparo
                    FILTRO_GESTAO_LOGS_CONTROLE_REPARO={
                        FILTRO_GESTAO_LOGS_CONTROLE_REPARO
                    }
                    filter={filter ?? filtroInicial}
                    filtroInicial={filtroInicial}
                    handleDateChange={handleDateChange}
                    setFilter={setFilter}
                    setPage={setPage}
                    setIdEmpreendimento={
                        setIdEmpreendimento as Dispatch<
                            SetStateAction<number[]>
                        >
                    }
                    setIdProduto={
                        setIdProduto as Dispatch<SetStateAction<number[]>>
                    }
                    setIdUsuario={setIdUsuario}
                    setIdEtapa={setIdEtapa}
                />

                <ExportExcel
                    baixarExcelController={async () =>
                        ExportarExcelListarGestaoLogsControleReparoService(
                            filter ? filter : filtroInicial
                        )
                    }
                    nomeArquivo={"Trilha Auditoria - Controle de Reparo"}
                />
            </div>
        </div>
    );
}
